export default __webpack_public_path__ + "static/media/Ducati.a29ae7fb.png";